import moment from 'moment';
import { IAllocationItemStore, YYYYMMDD } from './interfaces';

// AI generated
const sortByStartDateTheByTypeThenByCreatedAt = (items: IAllocationItemStore[]): IAllocationItemStore[] => {
  // Create a shallow copy to avoid mutating the original array
  const sortedItems = [...items];

  sortedItems.sort((a, b) => {
    // --- Condition 1: Sort by termStartDate (newest to oldest) ---
    // We get the timestamp for comparison. A newer date has a larger timestamp.
    // To sort newest to oldest (descending), we subtract a from b.
    const termStartDateB = new Date(b.termStartDate).getTime();
    const termStartDateA = new Date(a.termStartDate).getTime();

    if (termStartDateB !== termStartDateA) {
      return termStartDateB - termStartDateA;
    }

    // --- Condition 2: Sort by type ('additionalMinutes' before 'term') ---
    // If termStartDate is the same, we check the type.
    // We can assign a priority number to each type. Lower numbers come first.
    const typePriority = {
      'additionalMinutes': 1,
      'term': 2
    };

    const typeA_Priority = typePriority[a.type];
    const typeB_Priority = typePriority[b.type];

    if (typeA_Priority !== typeB_Priority) {
      return typeA_Priority - typeB_Priority; // Sorts by priority number (1 before 2)
    }

    // --- Condition 3: Sort by createdAt (newest to oldest) ---
    // If both termStartDate and type are the same, use createdAt as the tie-breaker.
    // Again, newest to oldest (descending).
    const createdAtB = new Date(b.createdAt).getTime();
    const createdAtA = new Date(a.createdAt).getTime();

    return createdAtB - createdAtA;
  });

  return sortedItems;
};

const addEndDateOneDayLessToNewerTerm = (sortedItems: IAllocationItemStore[]): IAllocationItemStore[] => {
  const [firstItem] = sortedItems;

  if(!firstItem) {
    return [...sortedItems];
  }

  let { termStartDate: termStartDateToCompare } = firstItem;
  let termEndDateToAssign: undefined | YYYYMMDD = undefined;

  return sortedItems.map((sortedItem) => {
    if(sortedItem.termStartDate !== termStartDateToCompare) {
      termEndDateToAssign = moment.utc(termStartDateToCompare).subtract(1, 'days').toISOString();
      termStartDateToCompare = sortedItem.termStartDate;
    }
    return {
      ...sortedItem,
      termEndDate: termEndDateToAssign
    };
  });
};

export { sortByStartDateTheByTypeThenByCreatedAt, addEndDateOneDayLessToNewerTerm };
